var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Import spreadsheet", centered: "", size: "lg" },
      on: { hide: _vm.closeHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$refs.modal.hide()
                        },
                      },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mx-1" }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.importAvailable || _vm.isImporting,
                      },
                      on: { click: _vm.importSpreadsheet },
                    },
                    [
                      _vm.isImporting
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v("\n        Import\n      "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("Multiselect", {
        staticClass: "mb-3",
        attrs: {
          options: _vm.layouts,
          loading: _vm.isLoading,
          searchable: "",
          multiple: "",
          "custom-label": _vm.customLabel,
          "track-by": "id",
          placeholder: "Add to existing layout (optional)",
        },
        on: { "search-change": _vm.searchLayouts, select: _vm.selectLayout },
        scopedSlots: _vm._u(
          [
            _vm.layouts.length < _vm.layoutsTotalCount
              ? {
                  key: "afterList",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "load-more-btn" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.isLoading,
                                variant: "outline-primary",
                              },
                              on: { click: _vm.getLayouts },
                            },
                            [_vm._v("\n          Load More\n        ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.selectedLayout,
          callback: function ($$v) {
            _vm.selectedLayout = $$v
          },
          expression: "selectedLayout",
        },
      }),
      _vm._v(" "),
      !_vm.selectedLayout.length
        ? _c(
            "b-form-group",
            {
              attrs: {
                label: "New layout name",
                "label-for": "spreadsheet-layout-name",
              },
            },
            [
              _c("b-form-input", {
                attrs: { id: "spreadsheet-layout-name" },
                model: {
                  value: _vm.layoutName,
                  callback: function ($$v) {
                    _vm.layoutName = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "layoutName",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }